import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAuth } from '../../contexts/AuthContext'
import { useFetch } from '../useFetch'

import { CONFIG } from '../../config'
import { AppConfig } from '../../types/contexts/ConfigContext'
import { ApiError } from '../../types/exception/errorStatus'
import { getErrorMessage } from '../../utils/exception/exceptionUtils'

export function useAppConfig() {
  const { t } = useTranslation('exceptions')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { authInfo } = useAuth()
  const { fetcher } = useFetch(authInfo?.accessToken, authInfo?.refreshToken)

  const resetState = () => {
    setLoading(false)
    setError(null)
  }

  const appConfig = async () => {
    setLoading(true)
    try {
      const data = await fetcher<AppConfig>(
        `${CONFIG.BOUNCE_API}/api/v1/config`
      )
      if (data) {
        setError(null)
        return data
      }
    } catch (caughtError) {
      console.log(caughtError)
      if (caughtError instanceof ApiError) {
        setError(getErrorMessage(caughtError.data))
      } else {
        setError(t('exceptions:unknown'))
      }
    } finally {
      setLoading(false)
    }
  }

  return { appConfig, loading, error, resetState }
}
